/* eslint-disable */
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var gogoproto_gogo_pb = require('../../gogoproto/gogo_pb.js');
goog.object.extend(proto, gogoproto_gogo_pb);
goog.exportSymbol('proto.admin.Manufacturer', null, global);
goog.exportSymbol('proto.admin.ManufacturerDescriptor', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.ManufacturerDescriptor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admin.ManufacturerDescriptor.repeatedFields_, null);
};
goog.inherits(proto.admin.ManufacturerDescriptor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.ManufacturerDescriptor.displayName = 'proto.admin.ManufacturerDescriptor';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admin.ManufacturerDescriptor.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.ManufacturerDescriptor.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.ManufacturerDescriptor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.ManufacturerDescriptor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.ManufacturerDescriptor.toObject = function(includeInstance, msg) {
  var f, obj = {
    manufacturer: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    slug: jspb.Message.getFieldWithDefault(msg, 3, ""),
    synonymsList: jspb.Message.getRepeatedField(msg, 4)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.ManufacturerDescriptor}
 */
proto.admin.ManufacturerDescriptor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.ManufacturerDescriptor;
  return proto.admin.ManufacturerDescriptor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.ManufacturerDescriptor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.ManufacturerDescriptor}
 */
proto.admin.ManufacturerDescriptor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.admin.Manufacturer} */ (reader.readEnum());
      msg.setManufacturer(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addSynonyms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.ManufacturerDescriptor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.ManufacturerDescriptor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.ManufacturerDescriptor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.ManufacturerDescriptor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManufacturer();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSynonymsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * optional Manufacturer manufacturer = 1;
 * @return {!proto.admin.Manufacturer}
 */
proto.admin.ManufacturerDescriptor.prototype.getManufacturer = function() {
  return /** @type {!proto.admin.Manufacturer} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.admin.Manufacturer} value */
proto.admin.ManufacturerDescriptor.prototype.setManufacturer = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.admin.ManufacturerDescriptor.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.ManufacturerDescriptor.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slug = 3;
 * @return {string}
 */
proto.admin.ManufacturerDescriptor.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.admin.ManufacturerDescriptor.prototype.setSlug = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string synonyms = 4;
 * @return {!Array<string>}
 */
proto.admin.ManufacturerDescriptor.prototype.getSynonymsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/** @param {!Array<string>} value */
proto.admin.ManufacturerDescriptor.prototype.setSynonymsList = function(value) {
  jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.admin.ManufacturerDescriptor.prototype.addSynonyms = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.ManufacturerDescriptor.prototype.clearSynonymsList = function() {
  this.setSynonymsList([]);
};


/**
 * @enum {number}
 */
proto.admin.Manufacturer = {
  MANUFACTURER_UNKNOWN: 0,
  ADVANCED_ARMAMENT_CORP: 1,
  AGUILA_AMMUNITION: 2,
  ARMALITE: 3,
  ATN: 4,
  BARNES: 5,
  BARRETT: 6,
  BERETTA: 7,
  BERSA: 8,
  BIANCHI: 9,
  BLACKHAWK: 10,
  BORE_SNAKE: 11,
  BRAVO_COMPANY: 12,
  BROWNING: 13,
  BSA_OPTICS: 14,
  BULLDOG_CASES: 15,
  BURRIS: 16,
  BUSHMASTER: 17,
  BUSHNELL: 18,
  CCI: 19,
  CMC_TRIGGERS: 20,
  COLT: 21,
  CRIMSON_TRACE: 22,
  CZ: 23,
  DANIEL_DEFENSE: 24,
  DAN_WESSON: 25,
  DESANTIS: 26,
  DPMS: 27,
  EOTECH: 28,
  FEDERAL: 29,
  FIOCCHI_AMMUNITION: 30,
  FN: 31,
  FROG_LUBE: 32,
  GALCO: 33,
  GEISSELE_AUTOMATICS: 34,
  GEMTECH: 35,
  GLOCK: 36,
  HENRY_REPEATING_ARMS: 37,
  HK: 38,
  HOPPES: 39,
  HORNADY: 40,
  IWIUS: 41,
  KAHR_ARMS: 42,
  KALASHNIKOV_USA: 43,
  KERSHAW: 44,
  KESTREL: 45,
  KIMBER: 46,
  KNIGHTS_ARMAMENT_COMPANY: 47,
  LANCER: 48,
  LEUPOLD: 49,
  LEWIS_MACHINE_AND_TOOL_COMPANY: 50,
  LIMBSAVER: 51,
  LONE_WOLF_DISTRIBUTORS: 52,
  LUCAS_OIL_PRODUCTS: 53,
  LWRC: 54,
  MAGLULA: 55,
  MAGNUM_RESEARCH: 56,
  MAGPUL: 57,
  MARLIN: 58,
  MECHANIX_WEAR: 104,
  MEPROLIGHT: 59,
  MOSSBERG: 60,
  NIKON: 61,
  NOVESKE: 62,
  PACHMAYR: 63,
  PEARCE_GRIP: 64,
  PELICAN: 65,
  PMC: 66,
  PRIMARY_WEAPONS_SYSTEMS: 67,
  PRO_MAG: 68,
  REMINGTON: 69,
  ROSSI: 70,
  RUGER: 71,
  SAFARILAND: 72,
  SAVAGE: 73,
  SELLIER_AND_BELLOT: 74,
  SIG_SAUER: 75,
  SILENCER_CO: 76,
  SMITH_AND_WESSON: 77,
  SPEER: 78,
  SPYDERCO: 79,
  STAG_ARMS: 80,
  STEYR_ARMS: 81,
  SUREFIRE: 82,
  TASER: 83,
  TAURUS: 84,
  TIKKA: 85,
  TIMNEY_TRIGGERS: 86,
  TRIJICON: 87,
  TROY: 88,
  TRUGLO: 89,
  TUL_AMMO_USA: 90,
  UMAREX: 92,
  UNCLE_MIKES: 93,
  US_OPTICS: 94,
  VERTX: 95,
  VIRIDIAN: 96,
  VLTOR: 97,
  WALTHER: 98,
  WARNE_SCOPE_MOUNTS: 99,
  WEATHERBY: 100,
  WEAVER: 101,
  WINCHESTER: 102,
  WINDHAM_WEAPONRY: 103
};

goog.object.extend(exports, proto.admin);
